<div class="row">
	<div class="col-lg-12">
		<div class="card">
			<div class="card-header align-items-center d-flex">
				<h4 class="card-title mb-0 flex-grow-1">Black Out Days</h4>
			</div>
			<!-- end card header -->

			<div class="card-body">
				<!-- Add Black  Out Day -->
				<ng-template #addBlackOutDay let-d="dismiss">
					<div class="modal-header">
						<h3 class="modal-title" id="modal-basic-title">Add Black Out Day</h3>
					</div>
					<div class="modal-body">
						<div class="containter" align="center">
							<div class="row mb-2">
								<div class="col-12 form-check form-switch d-flex justify-content-center gap-2">
									<input class="form-check-input" type="checkbox" role="switch" id="allDaySwitch" [(ngModel)]="allDay" />
									<label class="form-check-label" for="allDaySwitch">All Day</label>
								</div>
							</div>
							<div class="row">
								<div class="col-4">Initial Date</div>
								<div class="col-8"><span *ngIf="!allDay">Initial Hour</span></div>
							</div>

							<div class="row" align="center">
								<div class="col-4">
									<div class="input-group" style="border-radius: 5px 5px 5px 5px">
										<input id="date1" (click)="a.toggle()" class="form-control fomr-control-sm" placeholder="Initial Date" name="searchlead_creation" [(ngModel)]="newBlackOutDay.initial_date_hour" ngbDatepicker #a="ngbDatepicker" autocomplete="false" />
										<div class="input-group-append">
											<button class="btn btn-secondary btn-sm" (click)="a.toggle()" type="button" style="margin-right: 0px !important; padding: 8px">
												<i class="ri-calendar-event-fill" aria-hidden="true"></i>
											</button>
										</div>
									</div>
								</div>
								<div class="col-8">
									<ng-container *ngIf="!allDay">
										<select [(ngModel)]="newBlackOutDay.initial_hour" class="form-control" style="width: 5em; display: inline-block">
											<option value="00">00</option>
											<option value="01">01</option>
											<option value="02">02</option>
											<option value="03">03</option>
											<option value="04">04</option>
											<option value="05">05</option>
											<option value="06">06</option>
											<option value="07">07</option>
											<option value="08">08</option>
											<option value="09">09</option>
											<option value="10">10</option>
											<option value="11">11</option>
											<option value="12">12</option>
										</select>
										:
										<select [(ngModel)]="newBlackOutDay.initial_min" class="form-control" style="width: 5em; display: inline-block; margin-right: 5px">
											<option value="00">00</option>
											<option value="10">10</option>
											<option value="20">20</option>
											<option value="30">30</option>
											<option value="40">40</option>
											<option value="50">50</option>
										</select>

										<select [(ngModel)]="newBlackOutDay.initial_ampm" class="form-control" style="width: 5em; display: inline-block">
											<option value="AM" selected>AM</option>
											<option value="PM">PM</option>
										</select>
									</ng-container>
								</div>
							</div>
							<div class="row" align="center">
								<div class="col-4">End Date</div>
								<div class="col-8"><span *ngIf="!allDay">End Hour</span></div>
							</div>

							<div class="row" align="center">
								<div class="col-4">
									<div class="input-group" style="border-radius: 5px 5px 5px 5px">
										<input id="date2" (click)="b.toggle()" class="form-control fomr-control-sm" placeholder="End Date" name="searchlead_creation" [(ngModel)]="newBlackOutDay.end_date_hour" ngbDatepicker #b="ngbDatepicker" autocomplete="false" />
										<div class="input-group-append">
											<button class="btn btn-secondary btn-sm" (click)="b.toggle()" type="button" style="margin-right: 0px !important; padding: 8px">
												<i class="ri-calendar-event-fill" aria-hidden="true"></i>
											</button>
										</div>
									</div>
								</div>
								<div class="col-8">
									<ng-container *ngIf="!allDay">
										<select [(ngModel)]="newBlackOutDay.end_hour" class="form-control" style="width: 5em; display: inline-block">
											<option value="00">00</option>
											<option value="01">01</option>
											<option value="02">02</option>
											<option value="03">03</option>
											<option value="04">04</option>
											<option value="05">05</option>
											<option value="06">06</option>
											<option value="07">07</option>
											<option value="08">08</option>
											<option value="09">09</option>
											<option value="10">10</option>
											<option value="11">11</option>
											<option value="12">12</option>
										</select>
										:
										<select [(ngModel)]="newBlackOutDay.end_min" class="form-control" style="width: 5em; display: inline-block; margin-right: 5px">
											<option value="00">00</option>
											<option value="10">10</option>
											<option value="20">20</option>
											<option value="30">30</option>
											<option value="40">40</option>
											<option value="50">50</option>
										</select>

										<select [(ngModel)]="newBlackOutDay.end_ampm" class="form-control" style="width: 5em; display: inline-block">
											<option value="AM" selected>AM</option>
											<option value="PM">PM</option>
										</select>
									</ng-container>
								</div>
							</div>

							<div class="row">
								<div class="col-2 form-check form-switch" style="padding-top: 30px">
									<input *ngIf="recurrent.status" class="form-check-input" type="checkbox" role="switch" id="SwitchCheck2" checked (click)="recurrent.status = false" />
									<input *ngIf="!recurrent.status" class="form-check-input" type="checkbox" role="switch" id="SwitchCheck2" (click)="recurrent.status = true" />
									Recurrent
								</div>
								<div class="col-3 form-check form-switch" style="padding-top: 30px" *ngIf="recurrent.status">
									<input *ngIf="recurrent.weekly" class="form-check-input" type="checkbox" role="switch" id="SwitchCheck2" checked (click)="recurrent.monthly = false" />
									<input *ngIf="!recurrent.weekly" class="form-check-input" type="checkbox" role="switch" id="SwitchCheck2" (click)="recurrent.monthly = true" />
									<!-- <i class="fa fa-check-circle" aria-hidden="true" *ngIf="recurrent.weekly" (click)="recurrent.weekly = true; recurrent.monthly = false" style="cursor: pointer"></i>
										<i class="fa fa-circle-o" aria-hidden="true" *ngIf="!recurrent.weekly" (click)="recurrent.weekly = true; recurrent.monthly = false" style="cursor: pointer"></i>  -->
									Weekly
								</div>
								<div class="col-3 form-check form-switch" style="padding-top: 30px" *ngIf="recurrent.status">
									<input *ngIf="recurrent.monthly" class="form-check-input" type="checkbox" role="switch" id="SwitchCheck2" checked (click)="recurrent.weekly = false" />
									<input *ngIf="!recurrent.monthly" class="form-check-input" type="checkbox" role="switch" id="SwitchCheck2" (click)="recurrent.weekly = true" />
									<!-- <i class="fa fa-check-circle" aria-hidden="true" *ngIf="recurrent.monthly" (click)="recurrent.monthly = true; recurrent.weekly = false" style="cursor: pointer"></i>
										<i class="fa fa-circle-o" aria-hidden="true" *ngIf="!recurrent.monthly" (click)="recurrent.monthly = true; recurrent.weekly = false" style="cursor: pointer"></i>  -->
									Monthly
								</div>
								<div class="col-4" *ngIf="recurrent.status">
									<label for>How many Times</label>
									<input [(ngModel)]="recurrent.howManyTimes" type="number" class="form-control" />
								</div>
							</div>

							<div class="row">
								<div class="col-12">
									<label for>Alias:</label>
									<!-- <select [(ngModel)]="newBlackOutDay.user_id" name="" id="" class="form-control">
											<option value="0">Select Alias</option>
											<option value="{{ alias.id }}" *ngFor="let alias of allAlias">{{ alias.alias }} - {{ alias.name }}</option>
										</select> -->

									<div class="ng-autocomplete">
										<ng-autocomplete [data]="allAlias" [searchKeyword]="'alias'" placeholder="Select Alias" (selected)="selectAlias($event)" [itemTemplate]="itemTemplate" [notFoundTemplate]="notFoundTemplate"> </ng-autocomplete>

										<ng-template #itemTemplate let-item>
											<a [innerHTML]="item.alias"></a>
										</ng-template>

										<ng-template #notFoundTemplate let-notFound>
											<div [innerHTML]="notFound"></div>
										</ng-template>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="modal-footer p-3">
						<button type="button" (click)="d()" class="btn btn-danger">Cancel</button>
						<button type="button" (click)="adminSaveBODay(); d()" class="btn btn-secondary">Save</button>
					</div>
				</ng-template>

				<div class="container" *ngIf="!historyActive">
					<div class="row">
						<div class="col-12" align="center">
							<h3>Approve or Deny Black Out Days</h3>
						</div>
					</div>
					<br />
					<div class="row">
						<div class="col-3">
							<select [(ngModel)]="blackStatus" class="form-control" (change)="getBlackOutDays()">
								<option value="Pending">Pending</option>
								<option value="Approved">Approved</option>
								<option value="Denied">Denied</option>
								<option value="All">All</option>
							</select>
						</div>

						<div class="col-3">
							<input type="checkbox" [(ngModel)]="showInactiveUsers" (change)="getBlackOutDays()" />
							Show Inactive Users
						</div>
						<!-- <div class="col-3">
							<div class="input-group" style="border-radius: 5px 5px 5px 5px" *ngIf="blackStatus != 'Pending'">
								<input id="fromB" (click)="blackFrom.toggle()" (dateSelect)="getBlackOutDays()" class="form-control fomr-control-sm" placeholder="Initial Date" name="searchlead_creation" [(ngModel)]="dateBlackFrom" ngbDatepicker #blackFrom="ngbDatepicker" autocomplete="false" />
								<div class="input-group-append">
									<button class="btn btn-secondary btn-sm" (click)="blackFrom.toggle()" type="button" style="margin-right: 0px !important">
										<i class="ri-calendar-2-line action-icon" aria-hidden="true"></i>
									</button>
								</div>
							</div>
						</div>
						<div class="col-3">
							<div class="input-group" style="border-radius: 5px 5px 5px 5px" *ngIf="blackStatus != 'Pending'">
								<input id="toB" (click)="blackTo.toggle()" (dateSelect)="getBlackOutDays()" class="form-control fomr-control-sm" placeholder="Initial Date" name="searchlead_creation" [(ngModel)]="dateBlackTo" ngbDatepicker #blackTo="ngbDatepicker" autocomplete="false" />
								<div class="input-group-append">
									<button class="btn btn-secondary btn-sm" (click)="blackTo.toggle()" type="button" style="margin-right: 0px !important">
										<i class=" ri-calendar-2-line action-icon" aria-hidden="true"></i>
									</button>
								</div>
							</div>
						</div> -->
						<div class="col-3"></div>
						<div class="col-3" align="right">
							<button class="btn btn-primary" (click)="openAddBlackOutDay(addBlackOutDay)">
								<span><i class="ri-calendar-2-line action-icon" style="position: relative; top: 4px"></i></span>
								<span> Add BlackOut Day</span>
							</button>
						</div>
					</div>
					<br />
					<div class="row">
						<div class="col-12">
							<table class="table">
								<thead>
									<tr>
										<th class="center tcol-5">#</th>
										<th class="tcol-10">Name</th>
										<th class="tcol-15">Campaign</th>
										<th class="center tcol-10">Initial Date</th>
										<th class="center tcol-10">End Date</th>
										<th class="tcol-15">Reason</th>
										<th class="center tcol-10">Status</th>
										<th class="center tcol-15">Actions</th>
									</tr>
								</thead>
								<tbody>
									<tr *ngFor="let blackoutday of blackOutDays; let i = index" [attr.data-index]="i" class="ng-star-inserted">
										<td class="tcol-5" align="center">
											{{ i + 1 }}
										</td>
										<td class="tcol-10">
											{{ blackoutday.user_name }}
										</td>
										<td class="tcol-15">
											{{ blackoutday.campaign }}
										</td>

										<td class="tcol-15" align="center">
											{{ blackoutday.initial_date_hour | utcToLocal: "MMM d, y, h:mm a" }}
										</td>
										<td class="tcol-15" align="center">
											{{ blackoutday.end_date_hour | utcToLocal: "MMM d, y, h:mm a" }}
										</td>
										<td class="tcol-15" title="{{ blackoutday.reason }}">
											{{ blackoutday.reason }}
										</td>
										<td class="tcol-10" align="center">
											<span class="badge" [ngClass]="badgeStatus(blackoutday.status)">{{ blackoutday.status }}</span>
										</td>
										<td class="tcol-15" align="center">
											<button *ngIf="blackoutday.status === 'Pending'" (click)="changeBlackOutDayStatus(blackoutday, 'Approved')" class="btn btn-success btn-xsm action-btn" placement="left" ngbTooltip="Approve">
												<i class="ri-check-line action-icon" aria-hidden="true"></i>
											</button>
											<button *ngIf="blackoutday.status === 'Pending'" (click)="changeBlackOutDayStatus(blackoutday, 'Denied')" class="btn btn-danger btn-xsm action-btn" placement="right" ngbTooltip="Deny">
												<i class="ri-close-fill action-icon" aria-hidden="true"></i>
											</button>
											<button *ngIf="blackoutday.status != 'Pending'" (click)="changeStatusConfirmation(blackoutday)" class="btn btn-secondary btn-xsm action-btn" style="display: inline-block" placement="left" ngbTooltip="Change Status">
												<i class="ri-swap-box-line action-icon" aria-hidden="true"></i>
											</button>
											<button *ngIf="blackoutday.status != 'Pending'" class="btn btn-primary btn-xsm action-btn" (click)="getHistoryBlackOutDay(blackoutday)" style="display: inline-block" placement="right" ngbTooltip="History">
												<i class="ri-time-line action-icon" aria-hidden="true"></i>
											</button>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
				<!-- History Status BlackOut Days -->
				<div class="container" *ngIf="historyActive">
					<button class="btn btn-primary btn-xsm" (click)="backBODs()" style="margin-top: 15px">Back</button>
					<div class="row">
						<div class="col-12" align="center">
							<h1>History Status Changes</h1>
						</div>
					</div>
					<hr />

					<table class="table center-txt">
						<thead>
							<th>Who Change</th>
							<th>Update Datetime</th>
							<th>Status</th>
						</thead>
						<tbody>
							<tr *ngFor="let bod of historyBOD; let i = index" [ngClass]="{ 'current-state': i === 0 }">
								<td>{{ bod.who_change }}</td>
								<td>{{ bod.date_time | utcToLocal: "medium" }}</td>
								<td>
									<span class="badge" [ngClass]="badgeStatus(bod.to_status)">{{ bod.to_status }}</span>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</div>
</div>
